import { render } from "./talenta.svg?vue&type=template&id=37adeec4"
const script = {}
script.render = render

export default script